<template>
  <div  class="d-flex flex-column align-center">
    <v-row>
      <v-col cols="12" class="text-center mb-0 mb-md-10">
        <span class="title-font-secondary" v-html="t('title')"> </span>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center" v-if="$root.isDesktop">
      <v-col
        class="d-flex flex-row align-center justify-center mt-10"
        cols="12"
        md="4"
        v-for="(item, i) of items"
        :key="i"
      >
        <v-img height="auto" max-width="80px" :src="item.icon"></v-img>
        <span class="ml-4" v-html="item.text"></span>
      </v-col>
    </v-row>
    <v-row v-else dense style="width: 100%">
      <v-col cols="12">
        <v-carousel height="140px" v-model="model" hide-delimiters>
          <v-carousel-item v-for="(item, i) in items" :key="i">
            <v-container class="d-flex fill-height justify-center align-center">
              <v-img height="auto" max-width="80px" :src="item.icon"></v-img>
              <span class="ml-4" v-html="item.text"></span>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data: (vm) => ({
    model: 0,
    items: vm.benefits([
      "attention",
      "reservation",
      "management",
      "global",
      "report",
    ]),
  }),
  methods: {
    t(key, options = {}) {
      return this.$t(`public.landing.benefit.${key}`, options);
    },
    benefits(benefits) {
      return benefits.map((benefit) => ({
        icon: require(`@/assets/icons/icon-${benefit}.png`),
        text: this.t(benefit),
      }));
    },
  },
};
</script>
